<i18n locale="en">
{
  "label": "Pro"
}
</i18n>
<template>
  <span class="upsell-gate-badge" data-testid="upsell-gate-badge">
    {{ text ?? t('label') }}
  </span>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

defineProps<{
  text?: string
}>()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.upsell-gate-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.8px;
  text-transform: uppercase;
  color: var(--white);
  background: linear-gradient(131deg, #848ef5 28.46%, #1b6ab2 86.59%);
}
</style>
